// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DfTt","newExpiryDate":"styles_newExpiryDate__3Vu_p","footer":"styles_footer__19dgW"};